import { render, staticRenderFns } from "./PersonFields.vue?vue&type=template&id=5513a851"
import script from "./PersonFields.vue?vue&type=script&lang=js"
export * from "./PersonFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports